import { FC } from 'react';
import styles from './styles.module.scss';
import Typography from '@/components/shared/typography/typography.component';

interface ISliderLabel {
  min: number;
  max: number;
}

const SliderLabel: FC<ISliderLabel> = ({ min, max }) => {
  const formatPrice = (price: number) => {
    if (!price) return '';
    price /= 1000;
    let toStr = `${Math.round(price)}K`;
    if (price >= 1000) toStr = `${Math.round(price) / 1000}M`;
    return `${toStr} `;
  };
  return (
    <div className={styles.container}>
      <Typography variant="captionMedium">{formatPrice(min)}</Typography>
      <Typography variant="captionMedium">{formatPrice(max)}</Typography>
    </div>
  );
};

export default SliderLabel;
